<template>
  <div class="batchBinding">
    <div class="div-layout">
      <module-title title="批量绑定">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogAddVisible = true">
            批量新增
          </el-button>
        </div>
      </module-title>
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-position="right" label-width="100px">
        <el-form-item label="个人识别码：">
          <el-input
            v-model="searchForm.personalIdentityNumber"
            name="personalIdentityNumber"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="学校：">
          <el-input
            v-model="searchForm.schoolName"
            name="schoolName"
            maxlength="10"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="家长手机号：">
          <el-input
            v-model="searchForm.parentPhoneNumber"
            name="parentPhoneNumber"
            maxlength="11"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item style=" margin-left:50px;">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="dataList"
        highlight-current-row
        fit
        element-loading-text="Loading"
        class="list-table"
      >
        <el-table-column label="个人识别码" prop="personalIdentityNumber" align="center" />
        <el-table-column label="家长手机号" prop="parentPhoneNumber" align="center" />
        <el-table-column label="昵称" prop="nickname" align="center" />
        <el-table-column label="性别" prop="genderName" align="center" />
        <el-table-column label="生日" align="center">
          <template slot-scope="scope">
            {{ scope.row.birthDate | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="年级" prop="gradeName" align="center" />
        <el-table-column label="学校" prop="schoolName" align="center" />
      </el-table>
      <pagination
        :total="pageObj.total"
        :page.sync="pageObj.pageNum"
        :limit.sync="pageObj.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogAddVisible"
      title="批量新增"
      width="550px"
      @close="closeDialog"
    >
      <el-form
        ref="addBatchForm"
        class="add-batch-form"
        :model="addBatchForm"
        :rules="handleRules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="学校">
          <el-select v-model="addBatchForm.schoolCode" filterable class="handle-form-apptypes" @change="changeSchool">
            <el-option v-for="item in schoolList" :key="item.schoolCode" :label="item.schoolName" :value="item.schoolCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="addBatchForm.gradeCode" class="handle-form-apptypes" @change="changeGrade">
            <el-option v-for="item in gradeList" :key="item.gradeCode" :label="item.gradeName" :value="item.gradeCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="addBatchForm.classCode" class="handle-form-apptypes">
            <el-option v-for="item in classCodelist" :key="item.classCode" :label="item.className" :value="item.classCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="家长手机号" prop="parentPhoneNumber">
          <el-input
            v-model="addBatchForm.parentPhoneNumber"
            name="parentPhoneNumber"
            maxlength="11"
            class="handle-form-input"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDialog">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddBatchInfo"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBindList, getSchoolList, getClassList, batchBindingDesk } from '@/api/productOperation/batchBinding/index.js';
export default {
  name: 'BatchBinding',
  data() {
    var validateMobile = (rule, value, callback) => {
      const pattern = new RegExp(/^1\d{10}$/);
      if (value !== '' && value !== null) {
        if (!(pattern.test(value))) {
          callback(new Error('请输入正确的手机号'));
          return false;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      dialogAddVisible: false,
      searchForm: {
        schoolName: '',
        personalIdentityNumber: '',
        parentPhoneNumber: ''
      },
      listLoading: false,
      dataList: [],
      handleRules: {
        parentPhoneNumber: [
          { required: false, trigger: 'blur', validator: validateMobile }
        ]
      },
      addBatchForm: {
        classCode: '', // 班级编码
        gradeCode: '', // 年级编码
        parentPhoneNumber: '', // 家长手机号
        schoolCode: ''// 学校编码
      },
      ajaxLoading: false,
      pageObj: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      option: {},
      schoolList: [],
      gradeList: [],
      classCodelist: []
    };
  },
  filters: {
    formatDate(value) {
      if (!value) {
        return '';
      }
      return value.slice(0, 10);
    }
  },
  mounted() {
    this.getBatchList();
    this.getSchoolList();
  },
  methods: {
    closeDialog() {
      this.dialogAddVisible = false;
      this.addBatchForm = {
        classCode: '', // 班级编码
        gradeCode: '', // 年级编码
        parentPhoneNumber: '', // 家长手机号
        schoolCode: ''// 学校编码
      };
    },
    handleSearchFilter() {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = 10;
      this.option = {
        schoolName: this.searchForm.schoolName,
        personalIdentityNumber: this.searchForm.personalIdentityNumber,
        parentPhoneNumber: this.searchForm.parentPhoneNumber
      };
      this.getBatchList();
    },
    getBatchList() {
      this.listLoading = true;
      getBindList({ ...this.option, pageNum: this.pageObj.pageNum, pageSize: this.pageObj.pageSize }).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.dataList = res.data.list;
          this.pageObj.total = res.data.total;
        } else {
          this.dataList = [];
          this.pageObj.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.dataList = [];
        this.pageObj.total = 0;
        this.listLoading = false;
      });
    },
    handleAddBatchInfo() {
      this.$refs.addBatchForm.validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          batchBindingDesk(this.addBatchForm).then((res) => {
            this.ajaxLoading = false;
            this.dialogAddVisible = false;
            this.$refs.addBatchForm.clearValidate();
            this.$refs.addBatchForm.resetFields();
            this.$message({ type: 'success', message: '添加成功' });
            this.getBatchList();
          }).catch((err) => {
            console.log(err);
            this.ajaxLoading = false;
          });
        }
      });
    },
    pageCurriculumList(obj) {
      this.pageObj.pageNum = obj.page;
      this.getBatchList();
    },
    handleSizeChange(obj) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = obj.limit;
      this.getBatchList();
    },
    getSchoolList() {
      getSchoolList().then((res) => {
        this.schoolList = res.data;
      });
    },
    changeSchool() {
      this.addBatchForm.classCode = '';
      this.addBatchForm.gradeCode = '';
      this.getClassList();
    },
    getClassList() {
      getClassList({ schoolCode: this.addBatchForm.schoolCode }).then((res) => {
        this.gradeList = res.data;
      });
    },
    changeGrade(item) {
      this.addBatchForm.classCode = '';
      this.addBatchForm.gradeCode = item;
      this.gradeList.forEach((v) => {
        if (v.gradeCode === item) {
          this.classCodelist = v.classes;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.batchBinding{
  .add-batch-form{
    // /deep/.el-form-item__label:before {
    //   content: ' ';
    // }
  }
}
</style>
